module.exports = __webpack_public_path__ + "static/media/research-user-behaviour.c734ea32.png";